import CustomersProvider from './CustomersContext';
import Customers from './Customers';

let Index = () => {
    return (
        <CustomersProvider>
            <Customers />
        </CustomersProvider>
    )
}

export default Index;